<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { defineProps } from "vue";
defineProps({
  navItems: {
    type: Array,
  },
});

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: "smooth" });
};
</script>

<template>
  <div class="bg-yellow-900 w-full h-[450px] flex justify-center items-center">
    <!-- logo -->
    <div class="absolute w-[175px] md:w-[300px] -mt-56 -left-10 md:-left-20">
      <img src="../assets/images/emix-logo2-unscreen.gif" alt="logo" />
    </div>

    <!-- MENU -->
    <div class="flex flex-col md:flex-row justify-around items-center w-[70%]">
      <div
        v-for="navItem in navItems"
        :key="navItem.sectionId"
        class="my-4 md:my-20 cursor-pointer"
      >
        <li
          class="text-sm md:text-xl text-white font-bold list-none"
          @click.prevent="scrollToSection(navItem.sectionId)"
        >
          {{ navItem.name }}
        </li>
      </div>
    </div>
    <div class="absolute -mb-80 md:-mb-72 flex justify-around w-[200px]">
      <a href="https://www.behance.net/emmanuelonu1">
        <i class="bi bi-behance text-white text-xl md:text-2xl my-2"></i
      ></a>
      <a href="https://instagram.com/emixgraphics?igshid=ZGUzMzM3NWJiOQ==">
        <i class="bi bi-instagram text-white text-xl md:text-2xl my-2"></i
      ></a>

      <i class="bi bi-facebook text-white text-xl md:text-2xl my-2"></i>
    </div>
  </div>
</template>
